import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { CommonService, DialogService} from './../../services/index';

import { HelpComponent } from './../../system/help/help.component';
import { AboutComponent } from './../../system/about/about.component';
import { AuthHelper } from '../../shared/auth-helper';


@Component({
  selector: 'app-driver-layout',
  templateUrl: './driver-layout.component.html'
})
export class DriverLayoutComponent implements OnInit {
  public name: string;

  constructor(
    private dialogService: DialogService
  ) {
      this.name = AuthHelper.GetUserFullName();
  }

  ngOnInit() {
    CommonService.loadTheme();
    CommonService.themeOnClicked();
  }

  showHelp() {
    this.dialogService.open(HelpComponent)
  }

  showAbout() {
    this.dialogService.open(AboutComponent)
  }
}
